import { 
  MODAL_OPEN,
  MODAL_CLOSE,
  MODAL_CLOSE_ALL,
  // MODAL_REPLACE_ALL
} from './actionTypes';

export const modalOpen = (routeKey, params) => ({
  type: MODAL_OPEN,
  payload: { ...params, routeKey }
});

export const modalClose = (idx = null) => ({
  type: MODAL_CLOSE,
  payload: idx
});

export const modalCloseAll = () => ({
  type: MODAL_CLOSE_ALL
});




// WEBPACK FOOTER //
// ./src/actions/modals.js